import { IconButton, Link, styled, TextField } from "@mui/material";

export const FooterCol = styled("div")({
  position: "relative",
  paddingLeft: "40px",
  minHeight: "130px",
  "@media screen and (max-width: 991px)": {
    paddingLeft: 0,
    minHeight: 0,
  },
});

export const ColTitle = styled("span")({
  writingMode: "vertical-rl",
  position: "absolute",
  top: 0,
  left: 0,
  fontSize: "0.8rem",
  display: "block",
  textTransform: "uppercase",
  textAlign: "right",
  "@media screen and (max-width: 991px)": {
    marginTop: "1rem",
    writingMode: "horizontal-tb",
    position: "relative",
    textAlign: "left",
  },
});

export const ThemeLabel = styled("div")({
  padding: "0.375rem 0.75rem",
  background: "#2AAAA6",
  border: 0,
  color: "#FFF",
  textTransform: "uppercase",
  fontSize: "0.8rem",
  fontWeight: 600,
  borderRadius: 0,
  lineHeight: 2.5,
});

export const ThemeInput = styled(TextField)({
  background: "#fff",
  "& input": {
    border: "1px solid #2AAAA6",
    borderRadius: 0,
    fontSize: "0.8rem",
  },
  "& fieldset": {
    border: "none",
  },
});

export const Content = styled("div")({
  padding: "60px 0",
  "& h2": {
    display: "inline-block",
    margin: "0 0 60px 0",
    padding: "15px 20px",
    fontSize: "1.6rem",
    fontWeight: 600,
    color: "#393737",
  },
});

export const SubFooterLink = styled(Link)({
  color: "#777777",
  fontSize: "0.8rem",
  fontWeight: 400,
});

export const FooterLink = styled(Link)({
  color: "#FFF",
  fontSize: "0.8rem",
  fontWeight: 400,
});

export const Footer = styled("footer")({
  alignSelf: 'center',
  display: 'flex',
  marginTop: 130,
  background: '#ffffff0a',
  borderTopLeftRadius: '50px',
  borderTopRightRadius: '50px',
});

export const SubFooter = styled("div")({
  background: "#FFF",
  padding: "60px 0",
  color: "#777777",
});

export const ScrollUpButton = styled(IconButton)({
  borderRadius: 0,
  border: "2px solid #FFF",
  padding: 0,
  width: "34px",
  height: "34px",
  alignItems: "center",
  justifyContent: "center",
  "& svg": {
    color: "#fff",
    width: "1rem",
    height: "1rem",
  },
});
